import React from 'react';
import { Link } from 'react-router-dom';
import { IAdminElection } from 'store/reducers/elections/types';
import { facultyGradientByName } from 'theme/faculties';

function ElectionSummary({
    elections,
    onBack,
}: {
    elections: IAdminElection[];
    onBack: () => void;
}): React.ReactElement {
    const votes = elections.reduce(
        (sum, election) => sum + election.students_votes_count,
        0
    );
    const students = elections.reduce(
        (sum, election) => sum + election.students_count,
        0
    );
    const percent = (value: number): string =>
        new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 1 }).format(
            value * 100
        );

    return (
        <div className="admin-stats admin-stats--summary">
            <button
                className="admin-stats__summary-back"
                type="button"
                onClick={onBack}
            >
                ← К выборам
            </button>
            <header className="admin-stats__summary-heading">
                <h1>Общие результаты</h1>
            </header>
            <section
                className="admin-stats__summary-totals"
                aria-label="Общие результаты"
            >
                <div>
                    <span>Проголосовали</span>
                    <strong>{votes}</strong>
                </div>
                <div>
                    <span>Общая явка</span>
                    <strong>{percent(students ? votes / students : 0)}%</strong>
                </div>
            </section>
            <div
                className="admin-stats__summary-grid"
                style={{
                    gridTemplateColumns: `repeat(${Math.min(
                        elections.length,
                        4
                    )}, minmax(0, 1fr))`,
                }}
            >
                {elections.map(election => (
                    <article
                        className="admin-stats__summary-card"
                        key={election.id}
                        style={{
                            background: facultyGradientByName(
                                election.faculty?.name,
                                election.faculty?.short_name
                            ),
                        }}
                    >
                        <h2>{election.faculty?.name || election.name}</h2>
                        <div className="admin-stats__summary-card-data">
                            <div>
                                <strong>{percent(election.turnout)}%</strong>
                                <span>явка</span>
                            </div>
                            <div>
                                <strong>{election.students_votes_count}</strong>
                                <span>проголосовали</span>
                            </div>
                        </div>
                        <Link
                            className="admin-stats__summary-card-link"
                            to={`/admin/elections/${election.id}/results`}
                            aria-label={`Результаты выборов ${
                                election.faculty?.name || election.name
                            }`}
                        />
                    </article>
                ))}
            </div>
        </div>
    );
}

export default ElectionSummary;
